import { render, staticRenderFns } from "./linkbutton.vue?vue&type=template&id=a503e888&"
import script from "./linkbutton.vue?vue&type=script&lang=js&"
export * from "./linkbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a503e888')) {
      api.createRecord('a503e888', component.options)
    } else {
      api.reload('a503e888', component.options)
    }
    module.hot.accept("./linkbutton.vue?vue&type=template&id=a503e888&", function () {
      api.rerender('a503e888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/linkbutton.vue"
export default component.exports